import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

/**
 * Plus glyph. The "Add to ticket / slip" affordance across the AI
 * surfaces (SuggestedPickChip, Match of the Day). Mirrors the
 * prototype's `IC.plus` — a stroked cross, never a literal "+"
 * character. Theme-aware via `currentColor`.
 */
const Plus = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size = 16, className }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path d="M12 5v14M5 12h14" />
    </svg>
  ),
);

export default Plus;
